import axios from 'axios'
import url from './base-url';
const api = axios.create({
    baseURL: url,
})

export const getCompanyById = (companyId) => api.get(`/company/${companyId}`);
const apis = {
    getCompanyById
}

export default apis